<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <b-modal
        id="filter"
        size="md"
        no-close-on-backdrop
        hide-footer
        title="FILTRAR"
      >
        <div class="row">
          <div class="col-md-12">
            <label>STATUS</label>
            <select v-model="status" class="form-control">
              <option
                v-for="item in [
                  { value: 'ALL', text: 'TODOS' },
                  { value: 'ATIVO', text: 'ATIVO' },
                  { value: 'INATIVO', text: 'INATIVO' },
                ]"
                :key="item.value"
                :value="item.value"
              >
                {{ String(item.text).toUpperCase() }}
              </option>
            </select>
          </div>
          <div
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
          >
            <v-btn
              :disabled="loading"
              @click="paginate()"
              class="btn-filter"
              type="relief"
              ><i class="fas fa-filter mr-2 text-twenty"></i>
              {{ loading ? "CARREGANDO" : "FILTRAR" }}
            </v-btn>
          </div>
        </div>
      </b-modal>
      <b-overlay :show="loading" opacity="0.99">
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-12 pt-0">
            <h1 class="title-pages pt-1 check-text-center">
              FORMULÁRIOS DE SEMIOLOGIA RESPONDIDOS
            </h1>
          </div>
          <div
            class="col-xl-6 col-lg-6 col-md-4 col-sm-12 col-12 pt-0 text-right"
          >
            <v-btn
              @click="$bvModal.show('filter')"
              class="btn-filter mr-2"
              type="relief"
            >
              <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
            </v-btn>
          </div>

          <div class="col-xl-3 col-lg-4 col-md-5 col-sm-6 col-12 pb-0 pt-1">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              placeholder="PESQUISAR CUIDADOS"
              outlined
              dense
            />
          </div>
        </div>
        <div class="v-clean p-5 text-center" v-show="residents.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <v-data-table
          v-show="residents.length > 0"
          dense
          :headers="headers"
          :items="residents"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 75, 100],
            'items-per-page-text': 'Mostrar',
          }"
          @click:row="handleClickRowTable"
        >
          <template v-slot:[`item.date_of_birth`]="{ item }">
            <span
              v-b-tooltip.html
              :title="`Data de nascimento <br /> ${formatDate(
                item.date_of_birth,
                false
              )}`"
              >{{ getAge(item.date_of_birth) }} anos</span
            >
          </template>
        </v-data-table>
        <errors-messages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import api from "../services/api";

import { formatDate } from "../lib/format";

import { getAge } from "../lib/getAgeByDate";

import routes from "../routes";
import ErrorsMessages from "../templates/Components/ErrorsMessages.vue";

export default {
  name: "ResidentAnsweredSemiologies",
  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
  },
  data() {
    return {
      errors: [],
      status: "ATIVO",
      search: "",
      headers: [
        { text: "Status", value: "status_type_name" },
        { text: "Nome", value: "name" },
        { text: "Idade", value: "date_of_birth" },
        { text: "Sexo", value: "gender_name" },
      ],
      residents: [],
      loading: true,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    getAge,
    formatDate,
    handleClickRowTable({ id: resident_id }) {
      routes.push({ name: "answered-semiologies", params: { resident_id } });
    },
    async retrieve() {
      await this.paginate();
    },
    async paginate() {
      try {
        this.loading = true;

        const { status } = this;

        let params = { status };

        const response = await api.get("/rest-home/resident/paginate", {
          params,
        });

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.$bvModal.hide("filter");
          this.residents = residents;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
